import { Lightning } from "@lightningjs/sdk";
/** Owns one backdrop texture shared by all descendant GlassSurface panels. */
export class GlassScene extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._surfaces = new Set();
    }
    _init() {
        // The consumer declares Backdrop with its artwork in the scene template.
        // Declaring it here too would create duplicate refs in Lightning 2.
        this.childList.getByRef("Backdrop").renderToTexture = true;
        // The whole subtree has final coordinates here. Updating uniforms does not
        // schedule continuous rendering; unchanged geometry leaves each cache alone.
        this.onAfterUpdate = () => {
            this._surfaces.forEach((surface) => surface.syncBackdrop());
        };
    }
    $registerGlassSurface(surface) {
        this._surfaces.add(surface);
        surface.bindBackdrop(this.childList.getByRef("Backdrop"));
        return () => {
            this._surfaces.delete(surface);
            surface.bindBackdrop();
        };
    }
}
export default GlassScene;
//# sourceMappingURL=GlassScene.js.map